import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { CampaignSearchResponse } from '../models/campaign-management.model';

export const DateChanged = createAction(
  '[Campaign Management: Date]: Date Changed',
  props<{ dateFormat: string; date: Date }>(),
);

export const UpdateDate = createAction('[Campaign Management: Date]: Update Date');

export const UpdateDateSuccess = createAction(
  '[Campaign Management: Date]: Update Date Success',
  props<{ res: CampaignSearchResponse }>(),
);

export const UpdateDateFailed = createAction(
  '[Campaign Management: Date]: Update Date Failed',
  props<{ error: HttpErrorResponse }>(),
);
